import axios from "axios";
import { ReportTerminFilter } from "../interfaces/ReportTermin";

const API_URL = process.env.REACT_APP_API_URL

const INSERT_COMPANY_TEMPLATE_FILTER_REPORT_TERMIN = `${API_URL}company-view-templates/termin`
const UPDATED_COMPANY_TEMPLATE_FILTER_REPORT_TERMIN = `${API_URL}company-view-templates`
const INSERT_USER_TEMPLATE_FILTER_REPORT_TERMIN = `${API_URL}user-view-templates/termin`
const UPDATED_USER_TEMPLATE_FILTER_REPORT_TERMIN = `${API_URL}user-view-templates`
const MODIFY_TEMPLATE_FILTER_REPORT_TERMIN = `${API_URL}view-templates`

export const insertTemplateFilterReportTermin = async (type: string, leadTemplateId: string, name: string, content: string, position: number, token: string) => {
    return axios.post(type === 'company' ? INSERT_COMPANY_TEMPLATE_FILTER_REPORT_TERMIN : INSERT_USER_TEMPLATE_FILTER_REPORT_TERMIN, {
        leadTemplateId,
        name,
        content,
        position
    }, {
        headers: {
            'X-Auth-token': token
        }
    })
}

export const updateSortTemplateFilterReportTermin = async (data: ReportTerminFilter[], token: string, type: 'company' | 'personal') => {
    return axios.patch(type === 'company' ? UPDATED_COMPANY_TEMPLATE_FILTER_REPORT_TERMIN : UPDATED_USER_TEMPLATE_FILTER_REPORT_TERMIN, {
        data
    }, {
        headers: {
            'X-Auth-token': token
        }
    })
}

export const updateTemplateFilterReportTermin = async (id: string, leadTemplateId: string, name: string, content: string, token: string) => {
    return axios.patch(MODIFY_TEMPLATE_FILTER_REPORT_TERMIN + '/' + id,
        {
            leadTemplateId,
            name,
            content
        },
        {
            headers: {
                'X-Auth-token': token
            }
        });
}

export const deleteTemplateFilterReportTermin = async (id: string, token: string) => {
    return axios.delete(MODIFY_TEMPLATE_FILTER_REPORT_TERMIN + '/' + id,
        {
            headers: {
                'X-Auth-token': token
            }
        });
}